<template>
  <v-form v-model="valid" ref="form" lazy-validation>
    <v-list subheader three-line>
      <v-subheader>Module Controls</v-subheader>

      <v-layout>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="data.card_status" color="#00C853"></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Card</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.card_status === 1 || data.card_status === true
                    ? "Card available"
                    : data.card_status === 0 || data.card_status === false
                    ? "Card unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="data.cash_status" color="#00C853"></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Cash</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.cash_status === 1 || data.cash_status === true
                    ? "Cash available"
                    : data.cash_status === 0 || data.cash_status === false
                    ? "Cash unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.reservation_status"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Reservation</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.reservation_status === 1 ||
                  data.reservation_status === true
                    ? "Reservation available"
                    : data.reservation_status === 0 ||
                      data.reservation_status === false
                    ? "Reservation unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.presell_status"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Pre Sell</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.presell_status === 1 || data.presell_status === true
                    ? "Pre sell enabled"
                    : data.presell_status === 0 || data.presell_status === false
                    ? "Pre sell disabled"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>

        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.baggage_status"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Baggage</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.baggage_status === 1 || data.baggage_status === true
                    ? "Baggage available"
                    : data.baggage_status === 0 || data.baggage_status === false
                    ? "Baggage unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.trip_manifest_status"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Trip Manifest</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.trip_manifest_status === 1 ||
                  data.trip_manifest_status === true
                    ? "Status: On"
                    : data.trip_manifest_status === 0 ||
                      data.trip_manifest_status === false
                    ? "Status: Off"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.ticket_issuance_status"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Ticket Issuance</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.ticket_issuance_status === 1 ||
                  data.ticket_issuance_status === true
                    ? "Ticket Issuance enabled"
                    : data.ticket_issuance_status === 0 ||
                      data.ticket_issuance_status === false
                    ? "Ticket Issuance disabled"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>

        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="data.amount_status" color="#00C853"></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Free Ticket</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.amount_status === 1 || data.amount_status === true
                    ? "Free Ticket enabled"
                    : data.amount_status === 0 || data.amount_status === false
                    ? "Free Ticket  disabled"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
      </v-layout>
    </v-list>

    <v-divider></v-divider>

    <v-list subheader three-line v-if="data.device_print_out_controls">
      <v-subheader>Device Print Out Controls</v-subheader>

      <v-layout>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="
                  data.device_print_out_controls.arrival_gross_amount_status
                "
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Arrival Gross Amount</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.device_print_out_controls.arrival_gross_amount_status ===
                    1 ||
                  data.device_print_out_controls.arrival_gross_amount_status ===
                    true
                    ? "On"
                    : data.device_print_out_controls
                        .arrival_gross_amount_status === 0 ||
                      data.device_print_out_controls
                        .arrival_gross_amount_status === false
                    ? "Off"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="
                  data.device_print_out_controls.arrival_driver_amount_status
                "
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Arrival Driver Amount</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.device_print_out_controls
                    .arrival_driver_amount_status === 1 ||
                  data.device_print_out_controls
                    .arrival_driver_amount_status === true
                    ? "On"
                    : data.device_print_out_controls
                        .arrival_driver_amount_status === 0 ||
                      data.device_print_out_controls
                        .arrival_driver_amount_status === false
                    ? "Off"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="
                  data.device_print_out_controls
                    .arrival_dispatcher_amount_status
                "
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Arrival Dispatcher Amount</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.device_print_out_controls
                    .arrival_dispatcher_amount_status === 1 ||
                  data.device_print_out_controls
                    .arrival_dispatcher_amount_status === true
                    ? "On"
                    : data.device_print_out_controls
                        .arrival_dispatcher_amount_status === 0 ||
                      data.device_print_out_controls
                        .arrival_dispatcher_amount_status === false
                    ? "Off"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
      </v-layout>
    </v-list>
    <v-list subheader three-line v-if="data.device_print_out_controls">
      <v-layout>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="
                  data.device_print_out_controls.arrival_conductor_amount_status
                "
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Arrival Conductor Amount</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.device_print_out_controls
                    .arrival_conductor_amount_status === 1 ||
                  data.device_print_out_controls
                    .arrival_conductor_amount_status === true
                    ? "On"
                    : data.device_print_out_controls
                        .arrival_conductor_amount_status === 0 ||
                      data.device_print_out_controls
                        .arrival_conductor_amount_status === false
                    ? "Off"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
      </v-layout>
    </v-list>

    <v-divider></v-divider>

    <v-list subheader three-line>
      <v-subheader>User Controls</v-subheader>

      <v-layout>
        <v-flex md6>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="conductorStatus" color="#00C853"></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Conductor</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.conductor_status === 1 || data.conductor_status === true
                    ? "Conductor access on"
                    : data.conductor_status === 0 ||
                      data.conductor_status === false
                    ? "Conductor access off"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md6>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="dispatcherStatus" color="#00C853"></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Dispatcher</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.dispatcher_status === 1 ||
                  data.dispatcher_status === true
                    ? "Dispatcher is available"
                    : data.dispatcher_status === 0 ||
                      data.dispatcher_status === false
                    ? "Dispatcher is unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex md6>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="tellerStatus" color="#00C853"></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Teller</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.teller_status === 1 || data.teller_status === true
                    ? "Teller is available"
                    : data.teller_status === 0 || data.teller_status === false
                    ? "Teller is unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>

        <v-flex md6>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="backupDriverStatus" color="#00C853"></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Backup Driver</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.backup_driver_status === 1 ||
                  data.backup_driver_status === true
                    ? "Backup Driver access on"
                    : data.backup_driver_status === 0 ||
                      data.backup_driver_status === false
                    ? "Backup Driver off"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
      </v-layout>
    </v-list>

    <v-divider></v-divider>

    <v-list subheader three-line>
      <v-subheader>
        <v-flex>Vehicle Category</v-flex>
        <v-flex>Ticketing Type</v-flex>
      </v-subheader>
      <v-layout>
        <v-flex md6>
          <v-list-tile>
            <v-list-tile-action>
              <p></p>
              <p></p>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-action inset>
                <v-radio-group v-model="data.vehicle_category" color="#00C853">
                  <v-radio label="Bus" :value="0" color="#00C853"></v-radio>
                  <v-radio label="Jeep" :value="1" color="#00C853"></v-radio>
                </v-radio-group>
              </v-list-tile-action>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md6>
          <v-card elevation="0" style="margin: 0px 0px 0px 70px">
            <v-card-content>
              <v-radio-group v-model="data.ticketing_type" color="#00C853">
                <v-radio label="Standard" :value="0" color="#00C853"></v-radio>
                <v-radio
                  label="Tap In / Tap Out"
                  :value="1"
                  color="#00C853"
                ></v-radio>
                <v-radio label="Pre-sell" :value="2" color="#00C853"></v-radio>
                <v-radio label="Tap Out" :value="3" color="#00C853"></v-radio>
                <v-radio label="Puchase" :value="4" color="#00C853"></v-radio>
              </v-radio-group>
            </v-card-content>
          </v-card>
        </v-flex>
      </v-layout>
    </v-list>

    <v-divider></v-divider>

    <v-list subheader three-line>
      <v-subheader>Settlement</v-subheader>

      <v-layout>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-text-field
                v-model="data.settlement_duration"
                label="Duration"
                mask="######"
                required
                outline
                :rules="[
                  rules.required,
                  rules.number,
                  rules.maxFloor,
                  rules.minFloor,
                ]"
              ></v-text-field>
            </v-list-tile-action>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-text-field
                v-model="data.settlement_mdr"
                label="MDR (%)"
                required
                outline
                :rules="[rules.required, rules.number, rules.minFloor]"
              ></v-text-field>
            </v-list-tile-action>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-select
                v-model="data.settlement_time"
                label="Time"
                :items="settlementTimes"
                outline
              ></v-select>
            </v-list-tile-action>
          </v-list-tile>
        </v-flex>
      </v-layout>
            <v-subheader>
        <v-flex>Settlement Type</v-flex>
      </v-subheader>
      <v-layout>
        <v-flex md6>
          <v-list-tile>
            <v-list-tile-action>
              <p></p>
              <p></p>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-action inset>
                <v-radio-group v-model="data.settlement_type" color="#00C853">
                  <v-radio label="Standard Settlement" :value="0" color="#00C853"></v-radio>
                  <v-radio label="Teller Settlement" :value="1" color="#00C853"></v-radio>
                </v-radio-group>
              </v-list-tile-action>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
      </v-layout>

    </v-list>

    <v-divider></v-divider>

    <v-list subheader three-line v-if="tripmanifest">
      <v-subheader>Trip Manifest Access</v-subheader>
      <v-layout v-if="!tellerStatus">
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.trip_manifest_access.cashier"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Cashier</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.trip_manifest_access.cashier === 1 ||
                  data.trip_manifest_access.cashier === true
                    ? "Cashier available"
                    : data.trip_manifest_access.cashier === 0 ||
                      data.trip_manifest_access.cashier === false
                    ? "Cashier unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.trip_manifest_access.conductor"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Conductor</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.trip_manifest_access.conductor === 1 ||
                  data.trip_manifest_access.conductor === true
                    ? "Conductor available"
                    : data.trip_manifest_access.conductor === 0 ||
                      data.trip_manifest_access.conductor === false
                    ? "Conductor unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.trip_manifest_access.dispatcher"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Dispatcher</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.trip_manifest_access.dispatcher === 1 ||
                  data.trip_manifest_access.dispatcher === true
                    ? "Dispatcher available"
                    : data.trip_manifest_access.dispatcher === 0 ||
                      data.trip_manifest_access.dispatcher === false
                    ? "Dispatcher unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
      </v-layout>

      <v-layout v-if="!tellerStatus">
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.trip_manifest_access.driver"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Driver</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.trip_manifest_access.driver === 1 ||
                  data.trip_manifest_access.driver === true
                    ? "Driver available"
                    : data.trip_manifest_access.driver === 0 ||
                      data.trip_manifest_access.driver === false
                    ? "Driver unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.trip_manifest_access.inspector"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Inspector</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.trip_manifest_access.inspector === 1 ||
                  data.trip_manifest_access.inspector === true
                    ? "Inspector available"
                    : data.trip_manifest_access.inspector === 0 ||
                      data.trip_manifest_access.inspector === false
                    ? "Inspector unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.trip_manifest_access.teller"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Teller</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.trip_manifest_access.teller === 1 ||
                  data.trip_manifest_access.teller === true
                    ? "Teller available"
                    : data.trip_manifest_access.teller === 0 ||
                      data.trip_manifest_access.teller === false
                    ? "Teller unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
      </v-layout>

      <v-layout v-if="tellerStatus">
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.trip_manifest_access.teller"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Teller</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.trip_manifest_access.teller === 1 ||
                  data.trip_manifest_access.teller === true
                    ? "Teller available"
                    : data.trip_manifest_access.teller === 0 ||
                      data.trip_manifest_access.teller === false
                    ? "Teller unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex md4>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch
                v-model="data.trip_manifest_access.cashier"
                color="#00C853"
              ></v-switch>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Cashier</v-list-tile-title>
              <v-list-tile-sub-title>
                {{
                  data.trip_manifest_access.cashier === 1 ||
                  data.trip_manifest_access.cashier === true
                    ? "Cashier available"
                    : data.trip_manifest_access.cashier === 0 ||
                      data.trip_manifest_access.cashier === false
                    ? "Cashier unavailable"
                    : ""
                }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>
      </v-layout>

      <v-divider v-if="tellerStatus"></v-divider>

      <v-list v-if="tellerStatus" subheader three-line>
        <v-subheader>Teller Controls</v-subheader>
        <v-layout>
          <v-flex md2>
            <v-list-tile>
              <v-list-tile-action>
                <p></p>
                <p></p>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-action inset>
                  <v-radio-group v-model="data.vehicle_on" color="#00C853">
                    <v-radio
                      label="Dispatch"
                      :value="0"
                      color="#00C853"
                    ></v-radio>
                    <v-radio
                      label="Arrival"
                      :value="1"
                      color="#00C853"
                    ></v-radio>
                  </v-radio-group>
                </v-list-tile-action>
              </v-list-tile-content>
            </v-list-tile>
          </v-flex>
        </v-layout>
      </v-list>
    </v-list>

    <v-divider></v-divider>

    <v-list subheader three-line>
      <v-subheader>Ticket Controls</v-subheader>

      <v-layout>
        <v-flex md6>
          <v-list-tile>
            <v-list-tile-action>
              <v-text-field
                v-model="data.presell_ticket_expiration"
                label="Presell Ticket Expiration (hrs)"
                mask="##"
                required
                outline
                :rules="[rules.required, rules.number]"
              ></v-text-field>
            </v-list-tile-action>
          </v-list-tile>
        </v-flex>
      </v-layout>
    </v-list>
  </v-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        conductor_status: this.data.conductor_status ? 1 : 0,
        dispatcher_status: this.data.dispatcher_status ? 1 : 0,
        teller_status: this.data.teller_status ? 1 : 0,
        backup_driver_status: this.data.backup_driver_status ? 1 : 0,
        vehicle_category: this.data.vehicle_category ? 1 : 0,
        ticketing_type: this.data.ticketing_type,
        vehicle_on: this.data.vehicle_on ? 1 : 0,
        reservation_status: this.data.reservation_status ? 1 : 0,
        card_status: this.data.card_status ? 1 : 0,
        cash_status: this.data.cash_status ? 1 : 0,
        baggage_status: this.data.baggage_status ? 1 : 0,
        presell_status: this.data.presell_status ? 1 : 0,
        amount_status: this.data.amount_status ? 1 : 0,
        ticket_issuance_status: this.data.ticket_issuance_status ? 1 : 0,
        trip_manifest_status: this.data.trip_manifest_status ? 1 : 0,
        settlement_duration: this.data.settlement_duration,
        settlement_time: this.data.settlement_time,
        settlement_mdr: this.data.settlement_mdr,
        presell_ticket_expiration: this.data.presell_ticket_expiration,
        trip_manifest_access: {
          cashier: this.data.trip_manifest_access.cashier ? 1 : 0,
          conductor: this.data.trip_manifest_access.conductor ? 1 : 0,
          dispatcher: this.data.trip_manifest_access.dispatcher ? 1 : 0,
          driver: this.data.trip_manifest_access.driver ? 1 : 0,
          inspector: this.data.trip_manifest_access.inspector ? 1 : 0,
          teller: this.data.trip_manifest_access.teller ? 1 : 0,
        },
        device_print_out_controls: {
          arrival_gross_amount_status: this.data.device_print_out_controls
            .arrival_gross_amount_status
            ? 1
            : 0,
          arrival_driver_amount_status: this.data.device_print_out_controls
            .arrival_driver_amount_status
            ? 1
            : 0,
          arrival_dispatcher_amount_status: this.data.device_print_out_controls
            .arrival_dispatcher_amount_status
            ? 1
            : 0,
          arrival_conductor_amount_status: this.data.device_print_out_controls
            .arrival_conductor_amount_status
            ? 1
            : 0,
        },
        settlement_type: this.data.settlement_type,
      };
    },
    tripmanifest() {
      if (
        this.data.trip_manifest_status === 1 ||
        this.data.trip_manifest_status === true
      ) {
        return true;
      } else {
        return false;
      }
    },
    conductorStatus: {
      get() {
        return this.data.conductor_status;
      },
      set(value) {
        this.data.conductor_status = value;

        this.data.teller_status = 0;
      },
    },
    dispatcherStatus: {
      get() {
        return this.data.dispatcher_status;
      },
      set(value) {
        this.data.dispatcher_status = value;

        this.data.teller_status = 0;
      },
    },
    tellerStatus: {
      get() {
        return this.data.teller_status;
      },
      set(value) {
        this.data.teller_status = value;

        this.data.dispatcher_status = 0;
        this.data.conductor_status = 0;
        this.data.backup_driver_status = 0;
      },
    },
    backupDriverStatus: {
      get() {
        return this.data.backup_driver_status;
      },
      set(value) {
        this.data.backup_driver_status = value;
      },
    },
  },
  data() {
    return {
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        number: (value) => !isNaN(value) || "Must be number.",
        minFloor: (value) => value >= 1 || "The minimum number is 1.",
        maxFloor: (value) => value <= 30 || "The maximum number is 30.",
        // minRow: value => value >= 10 || "The minimum row is 10",
        // maxRow: value => value <= 15 || "The maximum row is 15.",
        // minColumn: value => value >= 4 || "The minimum row is 4.",
        // maxColumn: value => value <= 7 || "The maximum row is 7."
      },
      settlementTimes: [
        {
          text: "01:00 AM",
          value: "01:00:00",
        },
        {
          text: "02:00 AM",
          value: "02:00:00",
        },
        {
          text: "03:00 AM",
          value: "03:00:00",
        },
        {
          text: "04:00 AM",
          value: "04:00:00",
        },
        {
          text: "05:00 AM",
          value: "05:00:00",
        },
        {
          text: "06:00 AM",
          value: "06:00:00",
        },
        {
          text: "07:00 AM",
          value: "07:00:00",
        },
        {
          text: "08:00 AM",
          value: "08:00:00",
        },
        {
          text: "09:00 AM",
          value: "09:00:00",
        },
        {
          text: "10:00 AM",
          value: "10:00:00",
        },
        {
          text: "11:00 AM",
          value: "11:00:00",
        },
        {
          text: "12:00 PM",
          value: "12:00:00",
        },
        {
          text: "01:00 PM",
          value: "13:00:00",
        },
        {
          text: "02:00 PM",
          value: "14:00:00",
        },
        {
          text: "03:00 PM",
          value: "15:00:00",
        },
        {
          text: "04:00 PM",
          value: "16:00:00",
        },
        {
          text: "05:00 PM",
          value: "17:00:00",
        },
        {
          text: "06:00 PM",
          value: "18:00:00",
        },
        {
          text: "07:00 PM",
          value: "19:00:00",
        },
        {
          text: "08:00 PM",
          value: "20:00:00",
        },
        {
          text: "09:00 PM",
          value: "21:00:00",
        },
        {
          text: "10:00 PM",
          value: "22:00:00",
        },
        {
          text: "11:00 PM",
          value: "23:00:00",
        },
        {
          text: "12:00 AM",
          value: "00:00:00",
        },
      ],
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    },
  },
};
</script>

<style></style>
